import { FC } from "react";
import svgIcons from "../../../../assets/svg/svgIcons";
import { useTranslation } from "react-i18next";

type TGroupHierarchyAddGroupButtonProps = {
  level: number;
  onClick?: () => void;
};

const GroupHierarchyAddGroupButton: FC<TGroupHierarchyAddGroupButtonProps> = ({
  level,
  onClick,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'admins.groups.hierarchy' });
  return (
    <div className="relative h-10">
      <button
        type="button"
        className={`absolute w-full h-full group flex items-center justify-end gap-1 px-3 z-0 focus:ring-2 focus:ring-inset focus:ring-accent-blue-dark hover:bg-accent-blue-dark focus:bg-accent-blue-dark`}
        onClick={onClick}
      >
        <span className="text-sm text-heading-gray222 group-hover:text-white group-focus:text-white">
          {level === 0 ? t('add_parent_group') : t('add_sub_group')}
        </span>
        <img src={svgIcons.PlusBlue} alt="arrow" className="size-5 group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert" />
      </button>
    </div>
  )
}
export default GroupHierarchyAddGroupButton;